<div class="notification-card-playground">
  <h2 class="notification-card-playground__title">Notification card</h2>

  <div class="notification-card-playground__controls">
    <common-panel
      [data]="{
        title: 'Type',
        subtitle: type === 'toggle' ? 'toggle' : 'icon',
        showSubtitle: true,
        showChevron: true,
        bordered: false
      }"
      (select)="type = type === 'toggle' ? 'icon' : 'toggle'"
    ></common-panel>

    <common-toggle-panel
      *ngIf="type === 'toggle'"
      [activeLabel]="'Checked'"
      [inactiveLabel]="'Unchecked'"
      [checked]="checked"
      (change)="checked = $event"
    ></common-toggle-panel>
  </div>

  <common-notification-card
    [type]="type"
    title="Title text goes here in maximum two lines"
    subtitle="Subtitle text goes here in maximum two lines"
    leadingIcon="schedule"
    [checked]="checked"
    [showFooter]="true"
    [footer]="footer"
  ></common-notification-card>
</div>

